import { RoundFlag } from "./RoundFlag";

export function DEFlag() {
  return (
    <RoundFlag code="de">
      <rect width="20" height="6.67" fill="#000000" />
      <rect y="6.67" width="20" height="6.66" fill="#DD0000" />
      <rect y="13.33" width="20" height="6.67" fill="#FFCE00" />
    </RoundFlag>
  );
}
